module.exports = __webpack_public_path__ + "img/18.68d97776.jpg";